import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit{

  projectName:any
  constructor(private appservice:AppService) { }

  ngOnInit(): void {
  //  this.projectName= this.appservice.getProject()
  }
}

